module.exports = __webpack_public_path__ + "img/Foodrazor-logo.26bb7837.svg";